import { RowSelectionOptions } from '@ag-grid-community/core'
import { CloseOutlined, DeleteOutlined, MinusOutlined } from '@ant-design/icons'
import { Button, Divider } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTableContext } from './TableProvider'

const TableBulkDeleteButton: React.FC = () => {
  const { t } = useTranslation()

  const {
    handleBulkDeleteRecord,
    displayBulkDeleteBtn = false,
    disableTableControl = false,
    displayAddBtn,
    tableRef,
  } = useTableContext()

  const [isRowSelectionMultiple, setIsRowSelectionMultiple] = useState<boolean>(false)

  const rowSelection = useMemo<RowSelectionOptions | 'single' | 'multiple'>(() => {
    return {
      mode: 'multiRow',
    }
  }, [])

  const toggleBulkDelete = useCallback(() => {
    setIsRowSelectionMultiple(!isRowSelectionMultiple)
    tableRef.current?.api?.setGridOption('rowSelection', isRowSelectionMultiple ? 'single' : rowSelection)
  }, [isRowSelectionMultiple, tableRef, rowSelection])

  const _handleBulkDeleteRecord = useCallback(() => {
    if (isRowSelectionMultiple && handleBulkDeleteRecord) {
      handleBulkDeleteRecord()
    }
  }, [handleBulkDeleteRecord, isRowSelectionMultiple])

  const [selectedCount, setSelectedCount] = useState(0)

  const onSelectionChanged = (params: any) => {
    const selectedRows = params.api.getSelectedRows()
    setSelectedCount(selectedRows.length)
  }
  tableRef.current?.api?.addEventListener('selectionChanged', onSelectionChanged)

  if (!displayBulkDeleteBtn || disableTableControl) {
    return <></>
  }

  return (
    <>
      {!isRowSelectionMultiple && (
        <Button icon={<DeleteOutlined />} style={{}} type='primary' onClick={toggleBulkDelete} />
      )}
      {isRowSelectionMultiple && (
        <>
          <Button icon={<CloseOutlined />} style={{}} type='primary' onClick={toggleBulkDelete} />
          <Button
            icon={<MinusOutlined />}
            style={{}}
            type='primary'
            disabled={selectedCount === 0}
            onClick={_handleBulkDeleteRecord}
          >
            {t('common:delete')}
          </Button>
        </>
      )}
      {displayAddBtn && <Divider type='vertical' />}
    </>
  )
}

export default TableBulkDeleteButton
